import {
  safeJsonStringify
} from "./chunk-2UDLZC33.js";

// src/react/index.tsx
import React from "react";
function FlagDefinitions({
  definitions
}) {
  return /* @__PURE__ */ React.createElement(
    "script",
    {
      type: "application/json",
      "data-flag-definitions": true,
      dangerouslySetInnerHTML: {
        __html: safeJsonStringify(definitions)
      }
    }
  );
}
function FlagValues({
  values
}) {
  return /* @__PURE__ */ React.createElement(
    "script",
    {
      type: "application/json",
      "data-flag-values": true,
      dangerouslySetInnerHTML: {
        __html: safeJsonStringify(values)
      }
    }
  );
}
export {
  FlagDefinitions,
  FlagValues
};
//# sourceMappingURL=react.js.map